import { FloatingMenu } from "@/components/ui/FloatingMenu";
import type {
  HomeownerUser,
  ContractorUser,
} from "../../../../../hooks/queries/useMe";
import { getUserComplements } from "../../../../../hooks/complements/get-user-complements";
import UserAvatar from "../UserAvatar";
import NavLink from "@/pages/homepage/components/common/NavLink";
import { Fragment } from "react";

export default function UserAvatarMenu({ user }: UserAvatarMenuProps) {
  const { isContractor } = getUserComplements(user);
  const avatarSrc = user.photoUrl ?? undefined;

  const dashboardLink = user.accountLinks.find((link) => link.id === "dashboard");

  return (
    <FloatingMenu>
      <FloatingMenu.Trigger>
        <a href={dashboardLink?.url ?? "/"} className="flex gap-3 items-center !text-primary !no-underline">
          {avatarSrc ?
            (<UserAvatar
              src={avatarSrc}
              name={isContractor ? "My Account" : user.firstName}
              color="primary"
              className="w-6 h-6 cursor-pointer bg-default-200 border-default-200"
            />)
            : (<i className="fa fa-user-circle-o text-2xl"></i>)
          }
          {isContractor ? "My Account" : user.firstName}
        </a>
      </FloatingMenu.Trigger>
      <FloatingMenu.Content
        width="w-[180px]"
        classNames={{
          card: "p-4 flex flex-col gap-0.5 shadow-[0_5px_20px_rgb(0_0_0_/_25%)]",
          arrow: "left-1/2 -translate-x-1/2",
        }}
      >
        {user.accountLinks.map((link, index) => {
          const isLast = index === user.accountLinks.length - 1;

          return (
            <Fragment key={link.id}>
              {isLast && (
                <div
                  role="separator"
                  className="border-t border-solid border-default-200 pt-px sm:my-px"
                />
              )}
              <NavLink
                href={link.url}
                classNames={{
                  base: "gap-3 rounded-md px-3 py-2 text-sm transition-colors hover:bg-default-100",
                }}
              >
                {link.label}
              </NavLink>
            </Fragment>
          );
        })}
      </FloatingMenu.Content>
    </FloatingMenu>
  );
}

interface UserAvatarMenuProps {
  user: HomeownerUser | ContractorUser;
}